(() => {
  const keyFor = (label) => {
    const key = label.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace('œ','oe');
    if (key.startsWith('famille')) return 'family';
    if (key.startsWith('intensite')) return 'intensity';
    if (key.includes('tete')) return 'top';
    if (key.includes('coeur')) return 'heart';
    if (key.includes('fond')) return 'base';
    return null;
  };
  const enhance = () => {
    document.querySelectorAll('[data-aliyah-story]').forEach(story => {
      if (story.dataset.ready) return;
      const main = document.getElementById('MainContent') || document;
      const source = main.querySelector('.product__description');
      if (!source) return;
      let scan = source;
      if (source.aliyahOriginalHtml) {
        scan = document.createElement('div');
        scan.innerHTML = source.aliyahOriginalHtml;
      }
      const rows = new Map();
      const removals = [];
      let ambiguous = false;
      scan.querySelectorAll('p,li').forEach(node => {
        if (node.querySelector('p,li,a,img,table')) return;
        const clone = node.cloneNode(true);
        clone.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
        const text = clone.textContent.trim();
        const matches = [...text.matchAll(/(Famille(?:\s+olfactive)?|Intensit[eé]|Notes?\s+de\s+t[eê]te|Notes?\s+de\s+c(?:œ|oe)ur|Notes?\s+de\s+fond)\s*[:：]/giu)];
        if (!matches.length || /[\p{L}\p{N}]/u.test(text.slice(0,matches[0].index))) return;
        const parsed = [];
        for (let i=0; i<matches.length; i++) {
          const match=matches[i];
          const key=keyFor(match[1]);
          const value=text.slice(match.index+match[0].length,matches[i+1]?.index ?? text.length).trim();
          if (!key || !value) return;
          parsed.push([key,value]);
        }
        parsed.forEach(([key,value]) => {
          if (rows.has(key)) ambiguous=true;
          rows.set(key,value);
        });
        removals.push(node);
      });
      if (ambiguous || !rows.size) { story.dataset.ready='true'; return; }
      const labels = JSON.parse(story.querySelector('[data-aliyah-labels]').innerHTML);
      const list = story.querySelector('[data-aliyah-rows]');
      const icons={family:'❀',intensity:'◉',top:'✧',heart:'♡',base:'❧'};
      const fragment=document.createDocumentFragment();
      ['family','intensity','top','heart','base'].forEach(key => {
        if (!rows.has(key)) return;
        const row=document.createElement('div'); row.className='aliyah-story__row';
        const icon=document.createElement('span'); icon.className='aliyah-story__row-icon'; icon.setAttribute('aria-hidden','true'); icon.textContent=icons[key];
        const label=document.createElement('dt'); label.textContent=labels[key];
        const value=document.createElement('dd');
        const original=rows.get(key);
        const level=key==='intensity' ? original.match(/^(\d+)\s*\/\s*(\d+)$/) : null;
        if (level && Number(level[2])>0 && Number(level[2])<=5 && Number(level[1])<=Number(level[2])) {
          const dots=document.createElement('span'); dots.className='aliyah-story__dots'; dots.setAttribute('aria-hidden','true');
          for (let i=0;i<Number(level[2]);i++) { const dot=document.createElement('span'); dot.className='aliyah-story__dot'+(i<Number(level[1])?' is-filled':''); dots.append(dot); }
          value.append(dots);
        }
        value.append(document.createTextNode(original));
        row.append(icon,label,value); fragment.append(row);
      });
      list.append(fragment);
      source.aliyahOriginalHtml ||= source.innerHTML;
      const parents=new Set(removals.map(node=>node.parentElement));
      removals.forEach(node=>node.remove());
      parents.forEach(parent => {
        if (parent.matches('ul,ol') && !parent.children.length && !parent.textContent.trim()) {
          const heading=parent.previousElementSibling;
          if (heading && heading.matches('h2,h3,h4') && /pyramide\s+olfactive/i.test(heading.textContent)) heading.remove();
          parent.remove();
        }
      });
      story.querySelector('[data-aliyah-olfactory]').hidden=false;
      story.dataset.ready='true';
    });
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',enhance,{once:true}); else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();
